import React, { useState } from 'react';
import { updateCommunity } from '../../ajax_utils';
import { flashForReact } from '../../flash_react';


const TrialPeriod = ({ show, community }) => {
  const [trialPeriod, setTrialPeriod] = useState(community.trial_period_days);
  const [errors, setErrors] = useState('');
  const params = { trial_period_days: trialPeriod };

  const handleApiSuccess = (res) => {
      flashForReact('notice', res.message);
      setErrors('');
  };

  const handleApiErrors = (err) => {
      flashForReact('danger', err.errors)
      setErrors(err.errors);
  };

  return (
    show && (
      <div className="community-settings" id="trial-period">
        <div className="h2 mb-4 mt-n2">Trial Period</div>
        <div className="mb-6 form-group">
          <label className="mb-3">
            Free Trial Period
          </label>

          <div className="d-md-flex col-md-8 mb-6 justify-content-between">
            <div className="">
              <input
                type="radio"
                className="btn-check"
                name="options"
                id="btn-check-1-outlined-tp"
                autoComplete="off"
                defaultChecked={trialPeriod === 0 || trialPeriod === null}
              />
              <label
                className="btn btn-outline-primary px-7 col-12 mb-2 mb-md-0 admin-btn-lg"
                htmlFor="btn-check-1-outlined-tp"
                onClick={() => setTrialPeriod(0)}
              >
                None
              </label>
            </div>
            <div className="">
              <input
                type="radio"
                className="btn-check"
                name="options"
                id="btn-check-2-outlined-tp"
                autoComplete="off"
                defaultChecked={trialPeriod === 7}
              />
              <label
                className="btn btn-outline-primary text-nowrap px-7 col-12 mb-2 mb-md-0 admin-btn-lg"
                htmlFor="btn-check-2-outlined-tp"
                onClick={() => setTrialPeriod(7)}
              >
                7 days
              </label>
            </div>
            <div className="">
              <input
                type="radio"
                className="btn-check"
                name="options"
                id="btn-check-3-outlined-tp"
                autoComplete="off"
                defaultChecked={trialPeriod === 14}
              />
              <label
                className="btn btn-outline-primary text-nowrap px-7 col-12 mb-2 mb-md-0 admin-btn-lg"
                htmlFor="btn-check-3-outlined-tp"
                onClick={() => setTrialPeriod(14)}
              >
                14 days
              </label>
            </div>
            <div className="">
              <input
                type="radio"
                className="btn-check"
                name="options"
                id="btn-check-4-outlined-tp"
                autoComplete="off"
                defaultChecked={trialPeriod === 30}
              />
              <label
                className="btn btn-outline-primary text-nowrap px-7 col-12 mb-2 mb-md-0 admin-btn-lg"
                htmlFor="btn-check-4-outlined-tp"
                onClick={() => setTrialPeriod(30)}
              >
                30 days
              </label>
            </div>
          </div>
          <p className="text-gray-400 fs-85 col-md-8">
            Members will be automatically charged to their default payment
            method after trial period ends. If payment method does not exist,
            they will be locked from accessing the community until payment is
            made.
          </p>
        </div>
        <button
          className="btn btn-primary btn-lg col-md-3 col-12 update-btn mb-8"
          onClick={() => updateCommunity(community, params, handleApiSuccess, handleApiErrors)}
        >
        Update Trial Period
        </button>
      </div>
    )
  );
};

export default TrialPeriod;
